// Import model
import { LeadType } from '../models/LeadType';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadType - handles JSON serialization and deserialization with type validation
 */
export class LeadTypeSerializer {
  /**
   * Deserializes a JSON string into a LeadType instance
   */
  static deserialize(json: string): LeadType {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadType instance
   */
  static fromObject(obj: any): LeadType {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadType');
    }


    const instance: LeadType = {
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      id: obj['_id'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadType instances
   */
  static deserializeArray(json: string): LeadType[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadType instance to a JSON string
   */
  static serialize(instance: LeadType): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadType instance to a plain object
   */
  static toObject(instance: LeadType): any {
    return {
      'Name': instance.name,
      'Description': instance.description,
      '_id': instance.id,
    };
  }

  /**
   * Serializes an array of LeadType instances to a JSON string
   */
  static serializeArray(instances: LeadType[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
